export default __webpack_public_path__ + "static/media/costco-insurance-agency.780ce8b5.svg";